import { render, staticRenderFns } from "./latest_newsList.vue?vue&type=template&id=4ada45b6&scoped=true"
import script from "./latest_newsList.vue?vue&type=script&lang=js"
export * from "./latest_newsList.vue?vue&type=script&lang=js"
import style0 from "./latest_newsList.vue?vue&type=style&index=0&id=4ada45b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada45b6",
  null
  
)

export default component.exports